import React from 'react';
import { isPermitted, useGetUserQuery } from 'services/userApi';
import ErrorContainer from '../Error/Error';

/*
 * Primary UI component for user interaction
 */
const Error500Container = () => {
  const { data: user } = useGetUserQuery({});
  const isDashboardURLAccessible = isPermitted(user, 'analytics-menu');
  return (
    <ErrorContainer
      redirectURL={isDashboardURLAccessible ? '/dashboard' : '/invoices/submitted'}
      errorType={500}
      errorText="Internal Server Error"
      buttonLabel="Sign Out"
      isRedirectToLogin={true}
    />
  );
};

export default Error500Container;
